import { EPostbackStatus } from '../../../types'
import { IPostbackStatusLang } from '../../../types/lang'

export const postbackStatusLang: IPostbackStatusLang = {
	postback_status: {
		[EPostbackStatus.Lead]: 'lead',
		[EPostbackStatus.Sale]: 'sale',
		[EPostbackStatus.Reject]: 'reject',
	}
}